import { Navigate } from "react-router-dom";
import { useUserContext } from "../utils/hooks/UserContext";
import { useTokenValidation } from "../utils/hooks/useTokenValidation";
import { PulseLoader } from "react-spinners";

const ProtectedRoutes = ({ children, path, auth = [] }) => {
  const { isLoading, user } = useUserContext();
  const { isTokenValid } = useTokenValidation();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <p>
          <PulseLoader color="#00504E" size={20} />
        </p>
      </div>
    );
  }

  // Check both user state and token validity
  if (!user || !isTokenValid()) {
    return <Navigate to="/" replace state={{ from: path }} />;
  }

  if (!auth?.includes(user?.userType)) {
    return <Navigate to="/not-found" replace state={{ from: path }} />;
  }

  return children;
};

// Route protection for coaches with incomplete profiles
const ProfileCompletionRoute = ({ children }) => {
  const { user, isLoading } = useUserContext();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <p>
          <PulseLoader color="#00504E" size={20} />
        </p>
      </div>
    );
  }

  // Only apply profile completion check for coaches
  if (user?.userType === "coach" && user?.profile_complete !== "Yes") {
    return <Navigate to="/coach/onboarding-details" replace />;
  }

  return children;
};

export default ProtectedRoutes;
export { ProfileCompletionRoute };
